module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.cls
  }, [_c('a', {
    class: _vm.detailClass,
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "title semi-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.details.length > 0) ? _c('span', {
    staticClass: "details"
  }, [_vm._v(_vm._s(_vm.details))]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: _vm.iconClass
  }, [(_vm.thumbnail.length == 0) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.thumbnail.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.thumbnail))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef8b83a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/side_panel_item.vue
// module id = 1275
// module chunks = 1